import { useEffect } from "react";
import { useSetAtom } from "jotai";
import { pageTitleAtom } from "@/stores/atoms/page-title-atom";

export const useDynamicPageTitle = (title: string | null) => {
  const setPageTitle = useSetAtom(pageTitleAtom);

  useEffect(() => {
    setPageTitle(title);
    return () => setPageTitle(null);
  }, [title, setPageTitle]);
};
